import { render } from "./IPOPDataGridTable.vue?vue&type=template&id=9d9c580c&scoped=true"
import script from "./IPOPDataGridTable.vue?vue&type=script&lang=js"
export * from "./IPOPDataGridTable.vue?vue&type=script&lang=js"

import "./IPOPDataGridTable.vue?vue&type=style&index=0&id=9d9c580c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d9c580c"]])

export default __exports__